import React from 'react'

const WrappedText: React.FC<{text: string, className?: string}> = ({
  text,
  className
}) => (
  <div className={className}>
    {text.split('\n').map((segment, index, array) => {
      return (
        <>
          <span>{segment}</span>
          {index !== array.length - 1 ? (<br/>) : null}
        </>
      )
    })}
  </div>
)

export default WrappedText
